// Libraries
import React, { useEffect, useRef, useState } from "react";
import { Markup } from "interweave";
import styled from "styled-components";
// import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import { Button, Spinner } from "react-bootstrap";
// import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";

// Icons
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

// Styles
import "./HHPCOldChat.scss";
import { Switch } from "@mui/material";
import { marked } from "marked";

export const OldConvoContainer = styled.div`
  overflow-y: auto;
  width: -webkit-fill-available;
  width: -moz-available;
  height: 100%;
  flex: 1 1;
  &::-webkit-scrollbar {
    width: 8px;
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ada89a;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 6px;
  }

  // ::-webkit-scrollbar {
  //   width: 12px;
  // }

  // ::-webkit-scrollbar-track {
  //   -webkit-box-shadow: inset 0 0 6px rgb(71, 207, 222);
  //   border-radius: 10px;
  // }

  // ::-webkit-scrollbar-thumb {
  //   border-radius: 10px;
  //   -webkit-box-shadow: inset 0 0 6px rgb(67, 214, 72);
  // }

  // scrollbar-width: thin;
  // scrollbar-color: #ada89a transparent;
`;

export const ConvoDiv = styled.div`
  border: 0.5px solid grey;
  padding: 10px;
  border-radius: 15px;
  margin: 2%;

  .copy-icon {
    float: right;
    cursor: pointer;
    display: none;
    opacity: 0.2;
    transition: opacity 0.3s;

    &:hover {
      opacity: 1;
    }
  }

  &:hover .copy-icon {
    display: block;
    opacity: 0.2;
  }
`;

const HHPCOldChat = (props) => {
  const {
    chats,
    userInput,
    sendReport,
    getAnalysis,
    handleImageSelect,
    handleTableSelect,
    data,
    textOnly,
    setTextOnly,
    inlineRef,
    setInlineRef,
    addReport,
    setAddReport,
    isUseModel,
  } = props;
  const contentref = useRef();
  const [hideChat, setHideChat] = useState(
    Array.from({ length: chats.length - 1 })
      .fill(false)
      .concat(true)
  );
  useEffect(() => {
    // console.log(data);
    contentref.current.scrollIntoView({
      behavior: "smooth",
      block: "end",
      inline: "nearest",
    });
    contentref.current.focus();
  }, [data]);

  useEffect(() => {
    setHideChat(
      Array.from({ length: chats.length - 1 })
        .fill(false)
        .concat(true)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chats]);

  // const handleCopyClick = async (text) => {
  //   await navigator.clipboard.writeText(text);
  // };

  const hideResponse = (index) => {
    let hide = [...hideChat];
    hide[index] = !hideChat[index];
    setHideChat(hide);
  };

  const renderTable = (table, tableIndex, chatIndex) => {
    const uniqueKeys = new Set();

    table.Rows.forEach((obj) => {
      Object.keys(obj).forEach((key) => {
        uniqueKeys.add(key);
      });
    });
    const uniqueKeysArray = Array.from(uniqueKeys);
    return (
      <div key={tableIndex} className="w-100">
        <div className="d-flex" style={{ justifyContent: "space-between" }}>
          <div className="left-element">
            <h2>{table.Table_name}</h2>
          </div>
          <div className="right-element">
            <input
              style={{ width: "25px", height: "25px" }}
              type="checkbox"
              value={table.isShow}
              // id="flexCheckChecked"
              checked={table.isShow}
              onChange={() => {
                handleTableSelect(chatIndex, tableIndex);
              }}
            ></input>
          </div>
        </div>
        <table
          style={{
            tableLayout: "fixed",
            width: "100%",
            overflow: "auto",
            borderCollapse: "collapse",
            margin: "20px 0",
          }}
        >
          <thead className="w-100">
            <tr>
              {uniqueKeysArray.map((column, index) => (
                <th
                  key={index}
                  style={{
                    border: "1px solid #dddddd",
                    padding: "8px",
                    textAlign: "left",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  title={column}
                >
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="w-100">
            {table.Rows.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {uniqueKeysArray.map((column, columnIndex) => (
                  <td
                    key={columnIndex}
                    style={{
                      border: "1px solid #dddddd",
                      padding: "8px",
                      textAlign: "left",
                      wordBreak: "break-word",
                    }}
                  >
                    {String(row[column] || "NA")}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>

        {table.Interpretation ? (
          <p>
            <strong>Analysis: </strong>
            {table.Interpretation}
          </p>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "10px",
            }}
          >
            <Button
              variant="success"
              disabled={table.isLoader}
              onClick={() => getAnalysis(tableIndex, chatIndex)}
            >
              Get Analysis &nbsp;
              {table.isLoader ? <Spinner size="sm" /> : null}
            </Button>
          </div>
        )}
      </div>
    );
  };
  const renderUserInfo = (chat, index) => {
    return (
      <div className="user-info">
        <div className="user-info-details" onClick={() => hideResponse(index)}>
          <span className="d-flex w-100">Query: {chat.question}</span>
        </div>

        {!isUseModel && (
          <div onClick={() => hideResponse(index)}>
            {hideChat[index] ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
          </div>
        )}
      </div>
    );
  };

  const renderMarkup = (response, index, ques) => {
    const references = response.references
      ?.split("\n")
      .map((str) =>
        str.replace(
          /(https?:\/\/[^\s]+)/g,
          '<a href="$1" target="_blank" class="highlight-link">$1</a>'
        )
      )
      .join("<br>");
    const list = response.images?.reduce((imageList, image, index) => {
      if (index % 3 === 0) {
        const imgArr = [
          {
            image: image.image,
            url: image.url,
            index: index,
            isShow: image.isShow,
          },
        ];
        imageList.push(imgArr);
      } else {
        imageList[imageList.length - 1].push({
          image: image.image,
          url: image.url,
          index: index,
          isShow: image.isShow,
        });
      }
      return imageList;
    }, []);
    return (
      <div className="d-flex flex-column w-100">
        <Markup
          content={marked(
            `${isUseModel ? "Response: " : ""}${response.result}`
          )}
        />

        {response.images?.length > 0 && (
          <div className="images-container">
            {response.images?.length > 0 && (
              <div className="images-container-child" id="custom-scrollbar">
                {list.map((images, outerIndex) => (
                  <div
                    className="image-details"
                    key={ques + "" + index + "" + outerIndex}
                  >
                    {images.map((image, innerIndex) => {
                      return (
                        // <div>
                        <div
                          className="image-info"
                          key={
                            ques +
                            "" +
                            index +
                            "" +
                            outerIndex +
                            "" +
                            innerIndex
                          }
                        >
                          <input
                            className="form-check-input image_show"
                            type="checkbox"
                            value={image.isShow}
                            // id="flexCheckChecked"
                            checked={image.isShow}
                            onChange={() => {
                              handleImageSelect(index, image.index);
                            }}
                          ></input>
                          <img
                            src={`data:image/jpeg;base64,${image.image}`}
                            alt="From Flask"
                            className="cutom-image-details"
                          />
                          <a
                            href={image.url}
                            target="_blank"
                            class="highlight-link source-details"
                            title={image.url}
                          >
                            {image.url}
                          </a>
                        </div>
                        // </div>
                      );
                    })}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
        {/* <div className="w-100"> */}
        {response.tables?.length > 0 &&
          response.tables?.map((table, tableIndex) => {
            return renderTable(table, tableIndex, index);
          })}
        {/* </div> */}
        {references && (
          <div className="w-100" style={{ wordBreak: "break-all" }}>
            <Markup content={references} />
          </div>
        )}

        {response.cost && (
          <div className="my-3">
            <span>Cost: {response.cost}</span>
          </div>
        )}
      </div>
    );
  };

  const renderHHPCEVR = (chat, index) => {
    return (
      <ConvoDiv
        key={index}
        className={`old-chat ${
          // hideChat[index] && (chat.length === 1 || chat.length < 3)
          //   ? "evr-chat-full"
          //   : chat.length > 2 && hideChat[index]
          //   ? "evr-chat"
          //   : "h-10"
          !isUseModel && hideChat[index] ? "evr-chat-full" : "h-auto"
        }`}
      >
        {renderUserInfo(chat, index)}
        {!isUseModel && hideChat[index] && (
          <>
            <div className="response-container evr-response">
              {renderMarkup(chat.response, index, chat.question)}
            </div>
            {!isUseModel && (
              <div className="d-flex justify-content-end pt-3">
                <Button
                  onClick={() => {
                    sendReport(chat, index);
                  }}
                >
                  Add to report
                </Button>
              </div>
            )}
          </>
        )}
        {isUseModel && (
          <div className="response-container evr-response-use-model ">
            {renderMarkup(chat.response, index, chat.question)}
          </div>
        )}
      </ConvoDiv>
    );
  };
  return (
    <OldConvoContainer className="old-convo-container">
      {!isUseModel && (
        <div style={{ display: "flex" }}>
          <span style={Styles.textOnlyBtn}>
            <Switch
              size="small"
              disabled={!addReport}
              checked={textOnly}
              onChange={(e) => {
                setTextOnly(e.target.checked);
              }}
            />
            Text Only
          </span>

          <span style={Styles.textOnlyBtn}>
            <Switch
              size="small"
              checked={inlineRef}
              disabled={!addReport}
              onChange={(e) => {
                setInlineRef(e.target.checked);
              }}
            />
            Inline Ref
          </span>

          <span style={Styles.textOnlyBtn}>
            <Switch
              size="small"
              checked={addReport}
              onChange={(e) => {
                setAddReport(e.target.checked);
              }}
            />
            Report
          </span>
        </div>
      )}

      {chats.map((chat, index) => {
        if (chat.response) {
          return renderHHPCEVR(chat, index);
        } else {
          return (
            <ConvoDiv key={index}>
              <div className="text-left">Query: {chat.question}</div>
              <div className="text-left">Something went wrong</div>
            </ConvoDiv>
          );
        }
      })}
      <div ref={contentref}>
        {data !== "" && data !== null && (
          <ConvoDiv>
            {userInput && (
              <div className="text-left">
                <b>Query:</b> {userInput}
              </div>
            )}
            <span />
            {data && (
              <div className="text-left">
                <b>Response: </b>
                <Markup content={marked(data)} />
              </div>
            )}
          </ConvoDiv>
        )}
      </div>
    </OldConvoContainer>
  );
};

export default HHPCOldChat;

const Styles = {
  textOnlyBtn: {
    marginLeft: "10px",
    position: "relative",
    top: "8px",
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    color: "grey",
    fontSize: "15px",
  },
};
